import React from 'react';
import { useSearchParams } from 'react-router-dom';
import PowerBIEmbed from '../../components/PowerBIEmbed';
import { POWERBI_REPORT_ID } from '../../config/powerbi';
import styles from './ReportViewPage.module.css';

const ReportViewPage = () => {
  const [params] = useSearchParams();
  const reportId = params.get('reportId') || POWERBI_REPORT_ID;

  return (
    <div className={styles.reportView}>
      <PowerBIEmbed reportId={reportId} pageName={params.get('pageName') || ''} fit="page" />
    </div>
  );
};

export default ReportViewPage;
